import styled from 'styled-components';

export const OrderingToolComponent = styled.section`
  height: 100%;
`;
